import './CreateTextField.scss'

import Textarea from 'react-textarea-autosize'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isNullOrEmpty, removeCharacters } from '../../util/stringHelper'
import { KEYS_ENTER, KEYS_ESCAPE } from '../../constants/keyboardKeys'

const SAVE_CHANGES_DELAY_MS = 200

class CreateTextField extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      value: ''
    }
  }

  saveChanges = (isBlur) => {
    if (isNullOrEmpty(this.state.value)) {
      if (isBlur) {
        /* Solves bug 146171, related to clicking on an existing
          card to drag, which causes a blur event when create
          text field is enabled. This results in the wrong card
          being dragged and also prevents the viewdetails from
          appearing because the addCard is canceled so quickly.
          This timeout allows any card clicks to be handled before
          we cancel the CreateTextField.
          This should be removed in favor of a better solution. */
        setTimeout(this.props.onCancel, SAVE_CHANGES_DELAY_MS)
      } else {
        this.props.onCancel()
      }
    } else {
      this.props.onSave(isBlur, this.state.value)
      this.setState({ value: '' })
    }
  }

  onFocus = (event) => {
    this.setState({ isFocused: true })
  }

  onBlur = (event) => {
    this.setState({ isFocused: false })
    const isBlur = true
    this.saveChanges(isBlur)
  }

  onKeyPress = (event) => {
    if (event.key === KEYS_ENTER) {
      const isBlur = false
      this.saveChanges(isBlur)
      event.preventDefault()
      return false
    }

    return true
  }

  onKeyUp = (event) => {
    switch (event.key) {
      case KEYS_ESCAPE:
        this.props.onCancel()
        event.preventDefault()
        break
      default:
    }
  }

  onChange = (event) => {
    const filtered = removeCharacters(
      event.target.value,
      {
        removeTabs: this.props.disallowCr,
        removeNewline: this.props.disallowCr
      })
    this.setState({ value: filtered })
  }

  render() {
    return <div
      className={classNames({
        createTextField: true
      })}>
      {
        <Textarea
          autoFocus
          value={this.state.value}
          minRows={this.props.minRows || 1}
          maxRows={this.props.maxRows}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onKeyUp={this.onKeyUp}
          onKeyPress={this.onKeyPress}
          onFocus={this.onFocus}
          maxLength={this.props.maxLength} />
      }
    </div>
  }
}

CreateTextField.propTypes = {
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  maxLength: PropTypes.number,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disallowCr: PropTypes.bool
}

export default CreateTextField



// WEBPACK FOOTER //
// ./src/components/CreateTextField/CreateTextField.js